export const selectItems = [
	{
		link: 'https://www.finger.co.kr/',
		target: '_blank',
		title: '새창 열림',
		text: '핑거'
	},
	{
		link: 'https://www.fintech1.co.kr/',
		target: '_blank',
		title: '새창 열림',
		text: '핀테크'
	},
	{
		link: 'https://fingerprime.com/',
		target: '_blank',
		title: '새창 열림',
		text: '핑거프라임'
	},
	{
		link: 'https://accounz.io/',
		target: '_blank',
		title: '새창 열림',
		text: '어카운즈'
	},
	{
		link: 'http://www.fingeris.co.kr',
		target: '_blank',
		title: '새창 열림',
		text: '핑거아이에스'
	},
	{
		link: 'https://www.mycreditchain.io',
		target: '_blank',
		title: '새창 열림',
		text: '마이크레딧체인'
	},
	{
		text: '---------------------'
	},
	{
		link: 'https://www.upharos.co.kr/',
		target: '_blank',
		title: '새창 열림',
		text: '파로스'
	},
	{
		link: 'https://www.ucompas.co.kr',
		target: '_blank',
		title: '새창 열림',
		text: '컴패스'
	},
	{
		link: 'https://www.data-cube.co.kr',
		target: '_blank',
		title: '새창 열림',
		text: '데이터큐브'
	},
	{
		link: 'https://ipnft-issue.fingerservice.co.kr/login',
		target: '_blank',
		title: '새창 열림',
		text: 'IPNFT'
	},
	{
		text: '---------------------'
	},
	{
		link: 'https://www.amlhub.co.kr/',
		target: '_blank',
		title: '새창 열림',
		text: 'Finger AML Hub'
	}
];
